/**
 * [3.5 #4] 正文预览里的链接画成可点的 `<a>`。
 *
 * 所有卡片的正文原来都是 `{htmlToText(body)}` 一个纯文本节点 —— 商品链接在里头是
 * 一串灰字。切成片段的活在 lib/utils/productLinks.ts（顺便说明了为什么地址会丢），
 * 这里只负责把片段画出来，好让四处预览（单篇卡、任务卡、日历弹窗、Published）
 * 的链接款式**是同一套**。
 *
 * 外链一律 `target="_blank" + rel="noopener noreferrer"`：点商品链接不该把商家从
 * 正在审稿的这页带走。
 */
import type { BodySegment } from '../../lib/utils/productLinks';

export function DraftBodyText({ segments }: { segments: BodySegment[] }) {
  return (
    <>
      {segments.map((seg, i) =>
        seg.kind === 'link' ? (
          <a
            key={`l${i}`}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            className="break-words font-medium text-[#6b33ff] underline underline-offset-2 hover:text-[#5a29e0]"
          >
            {seg.text}
          </a>
        ) : seg.kind === 'image' ? (
          <img
            key={`i${i}`}
            src={seg.src}
            alt={seg.alt}
            loading="lazy"
            className="my-2 block max-h-64 w-auto max-w-full rounded-lg object-contain ring-1 ring-[#e2e8f0]"
          />
        ) : (
          <span key={`t${i}`}>{seg.text}</span>
        )
      )}
    </>
  );
}

export default DraftBodyText;
